import { Injectable, EventEmitter } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "src/app/services/authentication.service";
import { MessageBroadcasterService } from "src/app/services/message.service";
import { Helpers } from "src/app/services/app.helpers";

export enum RoomMessageType {
    Message,
    Attachement
}

export enum RoomMessageShowStatus {
    Viewed,
    NotViewed
}

export interface ChatUser {
    Id: string;
    Fullname: string;
}

export interface ChatRoom {
    Id: number;
    Name: string;
    Users: Array<ChatUser>;
    LastMessage: string;
    LastMessageActorName: string;
    LastMessageActorId: string;
    LastMessageType: RoomMessageType;
}

export interface RoomMessage {
    Id: number;
    RoomId: number;
    Message: string;
    SenderId: string;
    SenderName: string;
    DateSent: Date;
    ShowedStatuses: Array<{ UserId: string, Status: RoomMessageShowStatus }>;
    MessageType: RoomMessageType;
}

@Injectable()
export class ChatService {
    private newChatMessage: EventEmitter<RoomMessage> = new EventEmitter<RoomMessage>();

    get newChatMessageNotification() {
        return this.newChatMessage;
    }

    constructor(private http: HttpClient, private authService: AuthenticationService, private messageService: MessageBroadcasterService) {
        this.messageService.onMessage.subscribe((message: any) => {
            if (typeof this["on" + Helpers.capitalizeFirstLetter(message.event)] === "function") {
                this["on" + Helpers.capitalizeFirstLetter(message.event)](message);
            }
        });
    }

    public getUserRooms() {
        return this.http.get<Array<ChatRoom>>(`${environment.serverPath}/api/chat/user-rooms`);
    }

    public getUserRoomMessages(roomId: number) {
        return this.http.get<Array<RoomMessage>>(`${environment.serverPath}/api/chat/user-room-messages/${roomId}`);
    }

    public sendTextMessage(roomId: number, message: string) {
        return this.http.post(`${environment.serverPath}/api/chat/send`, {
            RoomId: roomId,
            Message: message,
            MessageType: RoomMessageType.Message
        });
    }

    public onNewChatMessage(message: any) {
        this.newChatMessage.emit(message.data);
    }
}